import { DotsSixIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const BlockMenu = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <DotsSixIcon {...rest} size={Sizes[size]} color={fill} />;
};

BlockMenu.displayName = 'BlockMenu';
